'use client'

import { Breakpoints } from 'fukku/styles/breakpoints'
import Image from 'next/image'
import { useLayoutEffect, useState } from 'react'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'

import { pointOfInterestImageLoaderFactory } from '../../../../../utils/pointOfInterestImageLoaderFactory'
import type { PointOfInterestImage } from '../../../../Home.type'

interface PromotionalBannerImageProps {
	image: PointOfInterestImage
}

const SMALL_ASPECT_RATIO = 1
const MEDIUM_HEIGHT = 572
const LARGE_HEIGHT = 648
const PERCENTAGE = 0.01

export const PromotionalBannerImage = ({
	image,
}: PromotionalBannerImageProps) => {
	const [isFirstRender, setIsFirstRender] = useState(true)
	const { isLargeOrGreater } = useResponsive()
	const pointOfInterest = {
		x: image.width * image.pointOfInterest.percentageX * PERCENTAGE,
		y: image.height * image.pointOfInterest.percentageY * PERCENTAGE,
	}

	const promotionalBannerImageLoader = pointOfInterestImageLoaderFactory(
		pointOfInterest,
		(width) => {
			if (isLargeOrGreater) {
				return LARGE_HEIGHT
			}
			if (width >= Breakpoints.medium) {
				return MEDIUM_HEIGHT
			}
			return width / SMALL_ASPECT_RATIO
		}
	)

	useLayoutEffect(() => {
		setIsFirstRender(false)
	}, [])

	if (isFirstRender) {
		return null
	}

	return (
		<Image
			fill
			aria-hidden
			alt={image.description ?? ''}
			src={image.url}
			style={{
				objectFit: 'cover',
				objectPosition: `${image.pointOfInterest.percentageX}% ${image.pointOfInterest.percentageY}%`,
			}}
			loader={promotionalBannerImageLoader}
			sizes={isLargeOrGreater ? '50vw' : '100vw'}
			draggable={false}
		/>
	)
}
